import { useQuery } from '@tanstack/react-query'
import { alertsApi, type RecentAlertsParams } from '../api/alerts'

// Query keys
const ALERTS_KEY = ['alerts']

/**
 * Fetch recently triggered alerts
 * @param params Optional filters (days, limit)
 */
export function useRecentAlerts(params?: RecentAlertsParams) {
  return useQuery({
    queryKey: [...ALERTS_KEY, 'recent', params],
    queryFn: () => alertsApi.getRecent(params),
    staleTime: 1000 * 60 * 5, // 5 minutes - alerts don't change frequently
  })
}
